import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';  // Correct import for v7
import './App.css';
import SignIn from './Pages/signIn';
import DealerRegistration from './Pages/DealerRegistration';
import SystemOverview from './Pages/SystemOverview';
import SystemManager from './Pages/SystemManager';
import Settings from './Pages/Settings';
import ClientPortal from './Pages/ClientPortal'
import Navigationbar from './Pages/Navigationbar';
import ShowDevices from './Pages/SystemOverview/ShowDevices';
import BySites from './Pages/SystemOverview/BySites';
import AboutDevice from './Pages/SystemOverview/AboutDevice';
import UserAccounts from './Pages/Settings/UserAccounts';
import AlertTab from './Pages/SystemOverview/AlertTab';

function App() {
  return (
    <BrowserRouter>
      <Routes>
      {/* SignIn Route */}
      <Route path="/" element={<SignIn />} />

      {/*  DealerRegistration */}
      <Route path="/new_dealer_registration" element={<DealerRegistration />} />

      {/* Navigation */}
      <Route path="/navigation" element={<Navigationbar />} />

      {/* System Overview */}
      <Route path="/system-overview/:menu?" element={<SystemOverview />} />

      {/* Client Portal */}
      <Route path="/client-portal/:menu?" element={<ClientPortal />} />

      {/* System Manager */}
      <Route path="/system-manager/:menu?" element={<SystemManager />} />

      {/* Settings */}
      <Route path="/settings/:menu?" element={<Settings />} />

      <Route path='/showDevices' element={<ShowDevices/>} />

      <Route path='/alerts' element={<AlertTab/>} />

      <Route path='/analytics' element={<BySites/>} />

      <Route path='/aboutDevice' element={<AboutDevice/>} />

      <Route path='/userAccounts' element={<UserAccounts/>} />

    </Routes>

    </BrowserRouter>  
  );
}

export default App;
